<template>
  <div class="video-cards-container" :class="{'has-options-tv':hasOptionsTv}">
    <!--<h2 class="title">-->
    <!--<span>{{ namedCategory }}</span>-->
    <!--</h2>-->
<!--   <pre>{{hasOptionsTv}}</pre>-->
    <div class="mb-4">
      <div
        role="group"
        aria-label="Basic example"
        class="btn-group mt-4"
        v-show="hasCategories && !hasOptions"
      >
        <button
          type="button"
          class="btn btn-lg"
          :class="[
            currentCategory === 'trends'
              ? isHeaderInfo  || hasOptionsFormation
                ? 'info-btn-primary'
                : 'btn-primary'
              : isHeaderInfo || hasOptionsFormation
              ? 'info-btn-outline-secondary'
              : 'btn-outline-secondary',
          ]"
          @click="setCategory('trends')"
        >
          {{ $t('categories.trends') }}
        </button>
        <button
          type="button"
          class="btn btn-lg"
          :class="
            currentCategory === 'popular'
              ? isHeaderInfo || hasOptionsFormation
                ? 'info-btn-primary'
                : 'btn-primary'
              : isHeaderInfo || hasOptionsFormation
              ? 'info-btn-outline-secondary'
              : 'btn-outline-secondary'
          "
          @click="setCategory('popular')"
        >
          {{ $t('categories.popular') }}
        </button>
        <button
          type="button"
          class="btn btn-lg"
          :class="
            currentCategory === 'all'
              ? isHeaderInfo || hasOptionsFormation
                ? 'info-btn-primary'
                : 'btn-primary'
              : isHeaderInfo || hasOptionsFormation
              ? 'info-btn-outline-secondary'
              : 'btn-outline-secondary'
          "
          @click="setCategory('all')"
        >
          {{ $t('categories.all') }}
        </button>
      </div>
    </div>
    <div class="cards-wrapper">
      <h3 class="rubrique-title" v-if="relatedVideos.length > 0 && hasCarousel && !isMG">
        {{ $t('titles.suggestions') }}
      </h3>
      <div v-if="hasCarousel && !isMG">
        <carousel
          navigation-prev-label="<i class='fo-icon-arrow-left'></i>"
          navigation-next-label="<i class='fo-icon-arrow-right'></i>"
          :loop="true"
          :mouse-drag="true"
          :navigation-enabled="true"
          :pagination-enabled="false"
          @pageChange="pageRelatedChanged"
          :per-page-custom="[[320, 1], [576, 2], [768, 3], [992, 4], [1200, 4]]"
        >
          <slide v-for="(video, index) in relatedVideos" :key="index">
            <video-vignette
              :video="video"
              :hide="['date']"
              card-type="default"
              @selected="selectVideo"
              :class="[{'style-image-cards' :hasOptionsTv}]"
            ></video-vignette>
          </slide>
        </carousel>
      </div>
      <div v-if="(isSideNav || !hasCategories) && !isHeaderInfo && !hasOptions && !hasOptionsTv">
        <h3 class="mt-0 rubrique-title">
          {{ $t('categories.' + currentCategory) }}
        </h3>
      </div>
      <div v-if="hasCarousel" :class="{'is-tv-options': hasOptionsTv}">
        <carousel
          navigation-prev-label="<i class='fo-icon-arrow-left'></i>"
          navigation-next-label="<i class='fo-icon-arrow-right'></i>"
          :loop="true"
          :mouse-drag="true"
          :navigation-enabled="true"
          :pagination-enabled="false"
          @pageChange="pageChanged"
          :per-page-custom="customPages"
        >
          <slide v-for="(video, index) in videos" :key="index">
            <video-vignette
              :video="video"
              card-type="default"
              :hide="hideElements"
              @selected="selectVideo"
              :class="[{'style-image-cards is-tv-options' :hasOptionsTv}]"
            ></video-vignette>
          </slide>
        </carousel>
        <div class="suggestions"  v-if="(hasOptionsTv  && isCir) && version && isMG" :class="[{  'hidden-suggest':   isCir && (currentCategory!=='trends' || currentTheme!==0)}]">
          <HorizantalCardCarousel :desktop="false" :mobile="true" ></HorizantalCardCarousel>
        </div>
        <infinite-loading :distance="10" v-if="hasOptionsTv && videos.length === 0 &&  !isEndReached" >
          <div slot="spinner" v-if="hasOptionsTv">
            <spinner-loader :show-text="false"></spinner-loader>
          </div>
          <div slot="no-more"></div>
        </infinite-loading>
        <div slot="no-results" v-show="videos.length === 0 &&  isEndReached && hasOptionsTv">{{ $t('labels.no_video') }}</div>
      </div>
      <div class="video-list" v-if="!hasCarousel">
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-6" v-for="(video , index) in videos" :key="index">
            <video-vignette
              :class="[{ 'style-cards': hasOptions, ' is-info-options': hasOptions|| hasOptionsFormation}]"
              :video="video"
              :hide="hideElements"
              @selected="selectVideo"
              v-scroll-to="{ el: '#video-wrapper', offset: -200 }"
            ></video-vignette>
          </div>
        </div>
        <infinite-loading @infinite="loadMoreVideos" :distance="10" v-if="!hasOptions" >
          <div slot="spinner" v-if="isHeaderInfo || hasOptionsFormation">
            <spinner-loader :show-text="true"></spinner-loader>
          </div>
          <div slot="spinner" v-if="!isHeaderInfo && !hasOptionsFormation">
            <div class="row">
              <div class="col-lg-3 col-md-4 col-sm-6">
                <card-loader></card-loader>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 d-none d-sm-block">
                <card-loader></card-loader>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 d-none d-md-block">
                <card-loader></card-loader>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 d-none d-xl-block">
                <card-loader></card-loader>
              </div>
            </div>
          </div>
          <div slot="no-more"></div>
          <div slot="no-results" v-show="videos.length === 0">{{ $t('labels.no_video') }}</div>
        </infinite-loading>
        <div class="row position-button"   v-if="hasOptions && videos.length > 0 && !isEndReached">
          <button

            type="button"
            class="btn btn-lg btn-outline-secondary button-style"
            @click="showAllVideos"
          >
            <span class="fo-icon-arrow-right"></span>
            <span class="show-all-button" >{{ $t('categories.show_all') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';

import VideoVignette from '~/node_modules/video-vignette/src/components/Component.vue';
import CardLoader from './common/CardLoader';
import HorizantalCardCarousel from './HorizantalCardCarousel';
import { categories } from '~/static/constants.js';
import { Carousel, Slide } from 'vue-carousel';
import SpinnerLoader from './common/SpinnerLoader';

import i18n from '../i18n/index.js';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';
import Mixin from '@/mixins/Mixin';

export default {
  name: 'VideoCards',
  components: {
    InfiniteLoading,
    VideoVignette,
    CardLoader,
    Carousel,
    Slide,
    SpinnerLoader,
      HorizantalCardCarousel
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  mixins: [Mixin],
  data() {
    return {
      infiniteState: null,
      categories,
        version:false
    };
  },
  watch: {
    isLoading(isLoading) {
        const pathname = this.$route.name;
      if (this.currentPage === 2 && !isLoading && this.videos.length > 0 && pathname!=='permalien') {
        this.selectVideo(this.videos[0]);
      }
      if (this.infiniteState) {
        if (this.isEndReached) {
          this.infiniteState.complete();
        } else if (!isLoading) {
          this.infiniteState.loaded();
          if (this.currentPage === 2 && this.keyword) {
            this.$scrollTo('.video-list', 500, { offset: -220 });
          }
        }
      }
    },
    videos(videos) {
      if (videos.length === 0 && this.infiniteState) {
        if (!this.isLoading) {
          this.loadMoreVideos();
        }
        this.infiniteState.reset();
      }
    },
    alauneVideos(videos) {
      if (videos.length === 0) {
        if (!this.isLoading) {
          this.loadMoreVideos();
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      videos: 'videos/getAllVideos',
      alauneVideos: 'videos/getAllVideos',
      isLoading: 'videos/getLoading',
      isEndReached: 'videos/getEndReached',
      currentCategory: 'videos/getCurrentCategory',
      currentTheme: 'videos/getCurrentTheme',
      currentPage: 'videos/getCurrentPage',
      keyword: 'videos/getKeyword',
      isFullWidth: 'layout/isFullWidth',
      currentSecondaryColor: 'layout/getCurrentSecondaryColor',
      currentPrimaryColor: 'layout/getCurrentPrimaryColor',
      isSideNav: 'layout/isSideNav',
      hasCarousel: 'layout/hasCarousel',
      hasCategories: 'layout/hasCategories',
      hasScroll: 'layout/hasScroll',
      relatedVideos: 'videos/getRelatedVideos',
      getCurrentSkin: 'layout/getCurrentSkin',
      getNavigation: 'layout/getNavigation',
      isHeaderInfo: 'layout/isHeaderInfo',
      hasOptions: 'layout/hasOptions',
      hasOptionsTv: 'layout/hasOptionsTv',
      hasOptionsFormation: 'layout/hasOptionsFormation'
    }),
    isCir(){
      return process.env.IS_CIR;
    },
      customPages(){
        if(this.hasOptionsTv){
            return [[320, 1.5], [576, 2], [768, 3], [992, 3], [1200, 4]]
        }else{
            return [[320, 1], [576, 2], [768, 3], [992, 3], [1200, 4]]
        }
      },
      isMG(){
          return process.env.CLIENT ? true :  false
      },
      hideElements(){
          if(this.hasOptions){
              return ['duration']
          }
          else if(this.hasOptionsFormation){
              return ['date']
          }
          else if(this.hasOptionsTv){
              return ['nbViews']
          }
          else{
              return ['date'];
          }
      },
  },
  methods: {
    ...mapActions('videos', [
      'paginateVideos',
      'setCurrentVideo',
      'getVideoMediaById',
      'setCurrentCategory',
      'fetchRelated',
      'handlePagination'
    ]),
    setCategory(category) {
      // this.setCurrentCategory(category);
      this.itemCategoryClicked(category);
      // this.$router.push({ name: 'home', params: { category } });
    },
    async loadMoreVideos($state) {
      if (!this.infiniteState) {
        this.infiniteState = $state;
      }
        if (this.isEndReached && this.infiniteState) {
        this.infiniteState.complete();
        return;
      }
        if($state && this.currentPage > 1 ){
             await this.handlePagination(true)
            await this.paginateVideos();
        }
    },
    showAllVideos() {
      if (!this.isEndReached) {
        this.paginateVideos();
      }
    },
    selectVideo(video) {
      this.$Progress.start();
      this.setCurrentVideo(video);
      if (!this.isHeaderInfo) {
        this.getVideoMediaById(video.id);
      }
    },
    pageChanged(page) {
      let length;
      length = this.videos.length
      if(page >0 ) {
        let nbPage = (this.hasOptionsTv && !this.isCir ? (window.innerWidth < 767 && window.innerWidth >= 576 ? 2 : window.innerWidth < 575 ? 1.5 : 3) : 8);
        let hasPaginate = page * nbPage >= length - (this.hasOptionsTv && !this.isCir && window.innerWidth < 767 ? (window.innerWidth < 575 ? 2 : nbPage) : 4);
        if ((!this.isEndReached) && hasPaginate && page > 0) {
          this.paginateVideos();
        } else {
          return;
        }
      }
    },
    pageRelatedChanged(page) {
      let length;
      if(page >0 ){
        length = this.relatedVideos.length;
        if (!this.isEndReached && page * 8 >= length - 4 ) {
          this.fetchRelated(process.env.ID_CHANNEL);
        } else {
          return;
        }
      }

    },
      updateVersion() {
          this.version = window.innerWidth < 992;
      }
  },
  created() {

  },
  async mounted() {
    // if(this.hasOptionsFormation || (this.hasOptions && !this.isHeaderInfo)){
    //todo maha verif commit (fix style for mgen)

      this.$nextTick(() => {
          this.updateVersion();
      });
      window.addEventListener('resize', () => {
          this.updateVersion();
      });
  },
};
</script>

<style lang="scss">
@import '../assets/scss/_variables.scss';
@import '../assets/scss/mix.scss';
.video-cards-container {
  &:not(.has-options-tv){
    padding: 0 calc(1rem - 15px);
  }
  &.has-options-tv{
    padding: 0;
  }
  h2.title {
    text-align: left;
    margin-top: 1em;
    font-size: 1.5em;
    @include hasColorTitre(var(--title-color));
    margin-bottom: 1em;
    span {
      border-bottom: 2px solid var(--secondary-color);
    }
  }
  .btn-group {
    .btn {
      font-size: 1rem;
      &:hover {
        color: #ffffff;
      }
    }
  }
}

.img-wrapper:after {
  content: '';
  position: absolute;
  width: 101%;
  height: 40%;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.1), #00000000);
}

.card-wrapper {
  &:not(.style-cards){
    .card-title {
      @include hasColorTitre(var(--title-color));
    }
  }

}
@media (min-width: 992px) {
  .video-cards-container {
    padding: 0 calc(2rem - 15px);
  }
}

.btn-primary {
  color: #fff;
  background-color: var(--secondary-color) !important;
  border-color: var(--secondary-color) !important;
  box-shadow: none !important;
}
.info-btn-primary {
  color: #0074b5 !important;
  border-color: var(--secondary-color) !important;
  border: none !important;
  border-radius: 0px !important;
  border-bottom: 1px solid var(--secondary-color) !important;
  box-shadow: none !important;
  &:hover {
    border-bottom: 1px solid var(--secondary-color) !important;
    color: #0074b5 !important;
  }
}
.btn-outline-secondary {
  border-color: var(--secondary-color) !important;
  color: var(--secondary-color) !important;
  box-shadow: none !important;
  &:hover {
    background-color: var(--secondary-color) !important;
    color: #fff !important;
  }
}

.info-btn-outline-secondary {
  border-color: #d2cfcf !important;
  box-shadow: none !important;
  border: none !important;
  border-radius: 0px !important;
  border-bottom: 1px solid #d2cfcf !important;
  &:hover {
    border-bottom: 1px solid var(--secondary-color) !important;
    color: #0074b5 !important;
  }
}

/*
   * IE support
   */

.card-wrapper {
  .card {
    .card-title {
      height: 1.2em;
    }
    .card-text {
      margin-bottom:1.5rem;
      font-size: 0.8em;
      color: #555;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      -o-text-overflow: ellipsis;
      line-height: 1.2em;
      height: 2.4em;
    }
    margin-bottom: 30px;
    .tag-info {
      font-size: 0.8em;
    }
  }
}
.VueCarousel {
  padding: 0 0.5em;
  border-radius: 0.15rem;
  margin-top: 1em;
  .VueCarousel-wrapper {
    .VueCarousel-slide {
      padding: 1em 0.5em;
    }
  }
  .VueCarousel-navigation {
    .VueCarousel-navigation-button {
      display: block;
      width: 3em;
      height: 3em;
      background-size: contain;
      background: white no-repeat center;
      border-radius: 1.5em;
      background-size: 1.5em;
      box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
      outline: none !important;
      color: var(--primary-color) !important;
      &.VueCarousel-navigation-prev {
        // background-image: url('data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==');
        left: 2.5em;
      }
      &.VueCarousel-navigation-next {
        // background-image: url('data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=');
        right: 2.5em;
      }
      @media screen and (max-width: 992px){
        display: none;
      }
    }
  }
}
.rubrique-title {
  @include hasColorTitre(var(--title-color));
  font-size: 1.4em;
  margin: 1.5em 0 0.5em;
  font-weight: 400;
}
.card-wrapper .card .card-text {
  word-break: break-word;
}
.position-button {
  display: flex;
  justify-content: center;
  padding: 1em 0;
}
.button-style {
  border: 1px solid var(--primary-color) !important;
  color: var(--primary-color) !important;
  width: 200px;
  height: 44px;
  background: #FFFFFF!important;
  border-radius: 50px!important;
  opacity: 1;
  align-items: center;
  display: flex;
  justify-content: center;
  display: flex;
  align-items: center;
  font-size: 14px!important;
  .fo-icon-arrow-right:after{
    font-weight: bold;
}
  .show-all-button{
    text-align: left;
    font-size:14px ;
    font-family:"Roboto-Regular";
    letter-spacing: 0;
    opacity: 1;
    font-size: 14px;
    padding:0 0 0 1em;
  }
  &:hover{
    background: var(--primary-color) !important;
    color: white !important;
  }
}
  .style-cards{
    padding-top: 5px;
    background: #6AA617 0% 0% no-repeat padding-box;
    border-radius: 3px;
    opacity: 1;
  }
  .style-image-cards{
    .img-wrapper{
      .card-img-top{
        border-radius: 10px !important;
        opacity: 1;
        padding: 5px;
      }
      &:after{
        position: relative;
      }
    }
      .tag-info .icon.duration {
        display: none;
      }
    &.is-tv-options{

      .card-date{
        .date{
          display: none;
        }
        background: #CBCECF 0% 0% no-repeat padding-box;
        border-radius: 3px;
        opacity: 1;
        position: absolute;
        left: 0.8rem;
        bottom: 0.5rem;
        color: white;
        padding: 0 0.4em;
        @media screen and (max-width: 1080px) and (min-width:992px){
          padding: 0 0.2em !important;
        }
      }
      .card-duration{
        background: #CBCECF 0% 0% no-repeat padding-box;
        border-radius: 3px;
        opacity: 1;
        position: absolute;
        right: 0.8rem;
        bottom: 0.5rem;
        color: white;
        padding: 0 0.4em;
        @media screen and (max-width: 1080px) and (min-width:992px){
          padding: 0 0.2em !important;
        }
      }
    }

  }
.card-wrapper {
    &.is-formation-options , &.is-info-options {
        .card-body {
            position: relative;
            .card-duration, .card-date {
                position: absolute;
                left: 0.8rem;
                bottom: 0.5rem;
            }
            .card-nbviews {
                position: absolute;
                right: 0.8rem;
                bottom: 0.5rem;
            }
        }
    }
}
.cards-wrapper{
  .is-tv-options{
    padding: 0 0.5em;
  }
}
  .video-list{
    overflow: hidden;
  }
.hidden-suggest{
  display: none!important;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoCards.vue